import { CSSProperties } from "react";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import clock from "../../../../imagenes/icons/clock.svg";
import dollarSign from "../../../../imagenes/icons/dollar-sign.svg";
import trendingUp from "../../../../imagenes/icons/trending-up.svg";
import ContentList from "../../../../ui/ContentList/ContentList";
import ContentListItem from "../../../../ui/ContentListItem/ContentListItem";
import "./Problem.scss";

type QuestionItem = {
	icon: string;
	text: string;
	background: string;
};

export type ProblemContent = {
	enabled: boolean;
	title: string;
	content: string;
	questions: {
		header: string;
		items: QuestionItem[];
	};
};

const IconMap = {
	"trending-up": trendingUp,
	clock: clock,
	"dollar-sign": dollarSign,
};

const Problem = ({ sectionContent }: { sectionContent: ProblemContent }) => {
	return (
		<section className="problem">
			<div className="content-container keep-color">
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
				<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
				<MarkdownRenderer>{sectionContent.questions.header}</MarkdownRenderer>
				<ContentList className="content-list--flex">
					{sectionContent.questions.items.map((item, index) => (
						<ContentListItem
							key={index}
							style={
								{
									"--item-background": item.background,
									"--animation-delay": `${index * 0.2}s`,
								} as CSSProperties
							}
							className="content-list__item--with-background content-list__item--icon-text">
							<img
								className="content-list__item__icon"
								src={IconMap[item.icon as keyof typeof IconMap]}
							/>
							<span className="content-list__item__text">{item.text}</span>
						</ContentListItem>
					))}
				</ContentList>
			</div>
		</section>
	);
};

export default Problem;
